/**
 * How long a suggestion assistant waits for its answer before it stops saying
 * one is coming. Generous — the model is slower than a request, and cutting a
 * real answer off would lose it — but finite, because the wait is now drawn on
 * screen and a websocket that goes quiet would otherwise pulse forever.
 */
export const SUGGESTION_TIMEOUT_MS = 45_000

/**
 * The timer behind that. One question in flight at a time per store, so
 * starting a new wait cancels the old one, and an answer stops it.
 *
 * A helper rather than three copies of the same three lines: all three
 * suggestion stores ask one question, draw the wait, and have no way of their
 * own to learn that the answer is not coming.
 */
export const createSuggestionTimeout = (ms = SUGGESTION_TIMEOUT_MS) => {
  let timer: ReturnType<typeof setTimeout> | undefined

  const stop = () => {
    if (timer === undefined) return
    clearTimeout(timer)
    timer = undefined
  }

  return {
    stop,
    start: (onExpire: () => void) => {
      stop()
      timer = setTimeout(() => {
        timer = undefined
        onExpire()
      }, ms)
    },
  }
}
